module.exports = __webpack_public_path__ + "img/r3.d8e440c3.jpg";